<template>
    <div class="offer_legend">
        <div class="legend_header">
            <div class="form-group mb-0 d-flex" style="align-items: center">
                <input v-model="show_legend" type="checkbox" class="toggle testing_acceptdeclineoffer" />
                <label class="block mb-0" @click="show_legend = !show_legend" style="cursor: pointer">
                    {{ show_legend ? $t('offer.legend_hide') : $t('offer.legend_show') }}
                </label>
            </div>
            <div class="show_video_tutorial" style="align-items: center" @click="openTutorialModal = true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16 10L18.5768 8.45392C19.3699 7.97803 19.7665 7.74009 20.0928 7.77051C20.3773 7.79703 20.6369 7.944 20.806 8.17433C21 8.43848 21 8.90095 21 9.8259V14.1741C21 15.099 21 15.5615 20.806 15.8257C20.6369 16.056 20.3773 16.203 20.0928 16.2295C19.7665 16.2599 19.3699 16.022 18.5768 15.5461L16 14M6.2 18H12.8C13.9201 18 14.4802 18 14.908 17.782C15.2843 17.5903 15.5903 17.2843 15.782 16.908C16 16.4802 16 15.9201 16 14.8V9.2C16 8.0799 16 7.51984 15.782 7.09202C15.5903 6.71569 15.2843 6.40973 14.908 6.21799C14.4802 6 13.9201 6 12.8 6H6.2C5.0799 6 4.51984 6 4.09202 6.21799C3.71569 6.40973 3.40973 6.71569 3.21799 7.09202C3 7.51984 3 8.07989 3 9.2V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18Z"
                        stroke="#565A70" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span>
                    {{ $t('offer.legend_video') }}
                </span>
            </div>
        </div>
        <div v-show="show_legend">
            <div class="img_container">
                <doffer-legend-svg />
                <div class="point-pulse point1">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            Tvoje logo
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.udaje_klienta_right ? 'active' : ''
                    } point2`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_client_right') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.udaje_klienta_left ? 'active' : ''
                    } point2_1`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_client_left') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.verejny_nazov ? 'active' : ''
                    } point3`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_title') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.sprievodny_text ? 'active' : ''
                    } point3_5`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_cover_text') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point4">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_summary') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point5">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_item') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point6">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_item_discount') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point7">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_subitem') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point8">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_item_gallery') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point9">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_item_cover') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point10">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_accept_option') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point11">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_pdf_option') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point12">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_total_price') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.firemne_udaje ? 'active' : ''
                    } point13`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_company_data') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.platnost ? 'active' : ''
                    } point14`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip left">
                            {{ $t('offer.legend_validity') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="point-pulse point15">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_logo') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div :class="`point-pulse ${activated.kontaktna_osoba ? 'active' : ''
                    } point16`">
                    <div class="point-pulse-container">
                        <div class="pulse_tooltip right">
                            {{ $t('offer.legend_contact_person') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="5" height="6" viewBox="0 0 5 6" fill="none">
                                <path
                                    d="M4.15826 2.43628C4.45995 2.65796 4.45995 3.10869 4.15826 3.33037L1.07313 5.59736C0.706752 5.86658 0.189871 5.60496 0.189871 5.15031L0.189871 0.616338C0.189871 0.161688 0.706753 -0.0999234 1.07313 0.169291L4.15826 2.43628Z"
                                    fill="#212541" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <TutorialVideo :openModal="openTutorialModal" @closeModal="openTutorialModal = false" />
    </div>
</template>

<script>
import DofferLegendSvg from "./DofferLegendSvg.vue";
import TutorialVideo from "./TutorialVideo.vue";
export default {
    props: ["activated", "offer_legend"],
    components: { DofferLegendSvg, TutorialVideo },
    data() {
        return {
            show_legend: true,
            openTutorialModal: false,
        };
    },
    created() {
        this.show_legend = this.offer_legend == 1 ? true : false;
    },
    watch: {
        show_legend(newValue, oldValue) {
            if (newValue != oldValue) {
                axios
                    .post(`/api/offer/changeOfferLegend`, {
                        offer_legend: this.show_legend,
                    })
                    .then((response) => { });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.offer_legend {
    margin-top: 65px;
    width: auto;
    .legend_header{
        display: flex;
        justify-content: space-between;
    }
    .show_video_tutorial{
        display: flex;
        align-items: center;
        cursor: pointer;
        gap: 5px;
        svg{
            width: 25px;
            height: 25px;
        }
        span{
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 18.75px;
            letter-spacing: 0%;
            text-align: center;     
            color: #565A70;
            text-decoration: underline;
        }
    }

    .img_container {
        margin-top: 14px;
        width: auto;
        position: relative;

        .point-pulse {
            position: absolute;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #f3385a;
            box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.25),
                0 0 0 16px rgba(243, 56, 90, 0.25);
            animation: pulsing 1.6s linear infinite;

            .point-pulse-container {
                width: 24px;
                height: 24px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            .point-pulse-container:hover {
                cursor: pointer;

                .pulse_tooltip {
                    opacity: 1;
                }
            }

            & .pulse_tooltip {
                pointer-events: none;
                opacity: 0;
                position: absolute;
                width: max-content;
                max-width: 200px;
                top: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-family: "Montserrat";
                font-size: 13px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                border-radius: 3.883px;
                background: #212541;
                transition: opacity 0.3s ease-in-out;

                svg {
                    position: absolute;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }

                &.left {
                    svg {
                        right: -6px;
                    }

                    transform: translate(-100%, -50%);
                    padding: 4px 8px 4px 8px;
                }

                &.right {
                    svg {
                        left: -6px;
                        transform: scale(-1, 1) translate(-50%, -50%);
                    }

                    transform: translate(20px, -50%);
                    padding: 4px 8px 4px 8px;

                    @media (max-width: 1250px) {
                        svg {
                            right: -6px;
                            left: unset;
                            transform: translate(-50%, -50%);
                        }

                        transform: translate(-100%, -50%);
                    }
                }
            }

            &.active {
                box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.7),
                    0 0 0 16px rgba(243, 56, 90, 0.7);
                animation: pulsing_bright 1.1s linear infinite;
            }

            &.point1 {
                top: 19px;
                left: 13px;
            }

            &.point2 {
                top: 20px;
                right: 25px;
            }

            &.point2_1 {
                top: 20px;
                right: 177px;
            }

            &.point3 {
                top: 78px;
                left: 16px;
            }

            &.point3_5 {
                top: 110px;
                left: 16px;
            }

            &.point4 {
                top: 157px;
                right: 128px;
            }

            &.point5 {
                top: 299px;
                left: 15px;
            }

            &.point6 {
                top: 363px;
                right: 23px;
            }

            &.point7 {
                top: 444px;
                left: 15px;
            }

            &.point8 {
                top: 603px;
                left: 15px;
            }

            &.point9 {
                top: 725px;
                left: 15px;
            }

            &.point10 {
                top: 880px;
                left: 15px;
            }

            &.point11 {
                top: 911px;
                left: 15px;
            }

            &.point12 {
                top: 888px;
                right: 27px;
            }

            &.point13 {
                bottom: 83px;
                left: 11px;
            }

            &.point14 {
                bottom: 75px;
                left: 236px;
            }

            &.point15 {
                bottom: 47px;
                left: 280px;
            }

            &.point16 {
                bottom: 83px;
                right: 27px;
            }
        }
    }

    label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0px;
        background: #c7d4eb;
        border-radius: 25px;
    }

    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        transition: all 0.2s ease;

        &:focus {
            outline: 0;
        }

        &:after {
            content: "";
            position: absolute;
            top: 4px;
            left: 3px;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background: white;
            box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
            transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
        }

        &:checked {
            border-color: #2ed8b6;
            background: #2ed8b6;
        }

        &:checked:after {
            transform: translatex(20px);
        }
    }
}

@keyframes pulsing {
    0% {
        box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.25),
            0 0 0 0px rgba(243, 56, 90, 0.25);
    }

    50% {
        box-shadow: 0 0 0 16px rgba(243, 56, 90, 0),
            0 0 0 8px rgba(243, 56, 90, 0.25);
    }

    50.0001% {
        box-shadow: 0 0 0 0 rgba(243, 56, 90, 0.25),
            0 0 0 8px rgba(243, 56, 90, 0.25);
    }

    100% {
        box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.25),
            0 0 0 16px rgba(243, 56, 90, 0);
    }
}

@keyframes pulsing_bright {
    0% {
        box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.7),
            0 0 0 0px rgba(243, 56, 90, 0.7);
    }

    50% {
        box-shadow: 0 0 0 16px rgba(243, 56, 90, 0),
            0 0 0 8px rgba(243, 56, 90, 0.7);
    }

    50.0001% {
        box-shadow: 0 0 0 0 rgba(243, 56, 90, 0.7),
            0 0 0 8px rgba(243, 56, 90, 0.7);
    }

    100% {
        box-shadow: 0 0 0 8px rgba(243, 56, 90, 0.7),
            0 0 0 16px rgba(243, 56, 90, 0);
    }
}
</style>
